import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import LotteryTab from '../../components/LotteryTab'
import Spacer from '../../components/Spacer';  
// import useBasisCash from '../../hooks/useBasisCash';

import moment from 'moment'
import Notice from '../../components/Notice';
// import useArticles,{ fetchArticles, useTokenInfo } from '../../hooks/useArticles';
import InfiniteScroll from 'react-infinite-scroller';
import _, { filter } from 'lodash'
import { Cron } from "croner";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { reaction } from 'mobx';
import stores from '../../state';
import { Empty, Spin, Button, message, Space } from 'antd';
// import { Article } from '../Home/components/Article'
import Articles, { Context } from '../../contexts/Articles';
import DocumentTitle from 'react-document-title'
// import { useConfig } from '../../hooks/useConfig';;
import Parse from 'parse'
// import useMessage from '../../hooks/useMessage';
import ZsxqEmpty from '../../components/ZsxqEmpty'
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import sleep from 'sleep-promise';
import bg from './bg.png'
import { TbTarget, TbTargetArrow } from "react-icons/tb";
import { TbTargetOff } from "react-icons/tb";
import n1 from './img/n1.png'
import n2 from './img/n2.png'
import n3 from './img/n3.png'
import n4 from './img/n4.png'
import n5 from './img/n5.png'
import n6 from './img/n6.png' 

import b1 from './img/b1.png'
import b2 from './img/b2.png'
import b3 from './img/b3.png'
import b4 from './img/b4.png'
import b5 from './img/b5.png'
import b6 from './img/b6.png' 
import target from './img/target.png'
import profile from '../PlanWinGo/img/profile.jpg'

import useDrawResult, { hit, useHistoryDrawResult } from '../../hooks/useDraw';
import { TabProps } from '../../components/LotteryTab';
import { useCountdown } from '../../hooks/useCountdown';
import { getCurrentIssueNumber, getNextIssueNumber, secondToMinuteStr } from '../../utils/util';
// import n0 from './img/0.png'
import FlipNumbers from 'react-flip-numbers';
import DrawHistoryModal from '../../components/DrawHistoryModal';
import BottomTab from '../../components/BottomTab';
import HitTrend from '../../components/HitTrend';
import { base, usePlanHistories, usePlanners } from '../../hooks/usePlanners';
import { StyledTopBar, StyledTopBarInner } from '../../components/TopBar/TopBar';
import Container from '../../components/Container';
import { LeftOutlined } from '@ant-design/icons';
import theme from '../../theme';
import { getTypeStr } from '../../components/LotteryTab/LotteryTab';
import { useTranslation } from 'react-i18next';
// import FN from 'react-flip-numbers'
 
const Home: React.FC = () => {
  //  let [displayedArticles,setDisplayedArticles] = useState([])
  // 用数组不太好，用对象比较好
//    const {articles,setArticles} = useArticles({})
    // console.log('home content',new Date())
    const {articles,setArticles} = useContext(Context)
    const [farestArticle,setFarestArticle] = useState<Parse.Object>()
    //  const farestArticle:Parse.Object = useMemo(()=>_.last(articles),[articles])
    const [displayedImages,setDisplayedImages] = useState([])
    //  const hasMore = useMemo(()=>(articles||[]).length > 0,[articles])
    const [hasMore,setHasMore] = useState(true)
    const [loading,setLoading] = useState(false)
    // useConfig()
    
   
    const [drawData,setDrawData] = useState<{[key:string]:[value:any]}>({})
    const {planners,loadingStatus:loadingPlanner} = usePlanners() 
   
        
  const history = useHistory() 

  const [numbers,setNumbers] = useState<string>('')
  const numberRef = useRef<string>('73464')
  const intervalRef = useRef<NodeJS.Timeout>()
   
  // const [selectedPlanType,setSelectedPlanType] = useState(planTypes[0])
  const {params}:{params:string} = useParams()
  const {lottery,typeId,pid,planType} = useMemo(()=>{
    const [lottery,typeId,pid,planType] = params.split('_')
    console.log('params',lottery,typeId,pid,planType)
    return {lottery,typeId,pid,planType}
  },[params]) 
  const planner = useMemo(()=>{
    // @ts-ignore
    return planners?.filter((p:any)=>p.pid === pid)[0]
  },[planners,pid])
  const pids = useMemo(()=>{
    // @ts-ignore
    return [pid]
  },[pid])
  console.log('pids',pids)
  // @ts-ignore
  const {hitProfiles,planHistories,loadingStatus,loadPlanHistories} = usePlanHistories(lottery,typeId,null, pids,planType)
  console.log('typeId',typeId)
  const reversedHitTrend = useMemo(()=>{
    try{
      return [...hitProfiles?.[0].hitTrend.filter(h=> h !== undefined)].reverse() || []
    }catch(e){
      console.error('e',e)
    }
    return []
  },[hitProfiles])

  const tab = useMemo(()=>{
    return {path:lottery+'_'+ typeId+'_latest',title:'',minute:'',type:0}
  },[])
  const {drawResult,refreshDrawResult} = useDrawResult(tab)
  const issueNumber = useMemo(()=>{
    return parseInt(getNextIssueNumber(parseInt(typeId)))
  },[])

  useEffect(()=>{
    sleep(1000).then(()=>{
      loadPlanHistories()
    })
  },[drawResult]) 
  const [countdown] = useCountdown(parseInt(typeId),issueNumber,refreshDrawResult)
  const {t} = useTranslation()
  // if(loadingStatus && !planHistories){
  //   return  <div style={{width:'100%',display:'flex',justifyContent:'center',marginTop:20}}>
  //       <Spin/>
  //     </div>
  // }

  
  // @ts-ignore
  // const [countdown] = useCountdown('1',drawResult?.issueNumber || 0,refreshDrawResultCallback)
  // const [open,setOpen] = useState(false)
  return (
    <Page showTopBar={false}>
       {/* {articles?articles?.length:'empty'} */}
      <DocumentTitle title='wingoanalyst'/>
      <StyledTopBar>
      <Container size="lg">
          <StyledTopBarInner>
            <div style={{width:50,marginLeft:10}}>
            <LeftOutlined onClick={()=>window.close()}/>
            </div> 
            <div>{lottery} {getTypeStr(parseInt(typeId))} {planType==='bs'?t('B/S'): planType==='oe'?  ((lottery==='WinGo'||lottery==='TrxWinGo')? t('Color'): t('O/E')): `${planType} ${t('Nums')}`}</div>
            <div style={{width:50,marginRight:10,fontSize:10, display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
          
            </div>
          </StyledTopBarInner>
        </Container>
      </StyledTopBar>
      <div style={{background:'#efefef',width:'100%',display:'flex',flexDirection:'column',alignItems:'center'}}>
      {/* <div style={{background:'#efefef',position:'absolute',left:0,right:0,top:0,bottom:0,zIndex:-1}}/> */}
        <Spacer size='lg'/> 
        
        <div style={{display:'flex',flexDirection:'row', background:theme.color.primary.main,width:'100%',paddingBottom:40,paddingTop:70,marginTop:-60, color:'white',alignItems:'center',paddingRight:20
      , borderRadius:40,borderTopLeftRadius:0,borderTopRightRadius:0 
      }}> 
            <img src={base+'avatar/'+pid?.replace('planner','')+'.jpeg'} style={{objectFit:'cover',minWidth:60,minHeight:60,maxWidth:60,maxHeight:60,  width:60,height:60,borderRadius:30,margin:10}}/>
              <span style={{display:'flex',justifyContent:'space-between',width:'100%'}}>
                <span>
                {planner?.name}   
                </span>
              <span>
              {t('Hit Rate')}: {hitProfiles?.[0].hitRate}
              </span>
            </span>
        </div> 
        
          <div style={{width:'calc(100% - 20px)',display:'flex',alignItems:'center', marginTop:-25, background:'linear-gradient(to bottom,#fde6e6,white)',borderRadius:10, boxShadow:'2px 2px 2px rgba(0,0,0,.015)',padding:10,
              }}>
            <img src={target} style={{width:30,height:30}}/>
            {/* Hit Rate: {hitProfiles?.[0].hitRate} */}
            <span style={{marginLeft:10,marginRight:10}}>{t('Trend')}</span>
            <span style={{display:'flex',alignItems:'center'}}> 
              {reversedHitTrend.map((h,i,arr)=><>
                  {/* <span style={{color:h? theme.color.primary.main:'#ddd' }}>H</span>  */}
                  {h ?<TbTargetArrow style={{fontSize:15,color:theme.color.primary.main,fontWeight:'thin'}}/>:
                        <TbTargetOff style={{fontSize:15,color:'#bbb',fontWeight:'thin'}}/>}
                {i!==arr.length -1 &&<span style={{color:'#aaa',fontWeight:'bold',marginLeft:2,marginRight:2,fontSize:10}}>{'<'}</span>} 
              </>)}
            </span>
          </div> 
          {loadingStatus && !planHistories  &&  <div style={{width:'100%',display:'flex',justifyContent:'center',marginTop:20,marginBottom:document.body.clientHeight-50}}>
              <Spin/>
            </div>}
            {(planHistories?.[0]||[]).map((draw:any,index:number)=>{
              return <div style={{background:'white',borderRadius:10,padding:10,width:'calc( 100% - 20px)',marginTop:10,display:'flex',flexDirection:'column'}}>
                
                <span style={{fontWeight:'bold'}}>{t('Period')}: {draw.issueNumber}</span>
                <div style={{width:'100%',height:1,background:'#eee',marginTop:10,marginBottom:10}} />
                <div style={{display:'flex',flexDirection:'row'}}>
                  <div style={{display:'flex',flexDirection:'column',flex:1,marginRight:10 }}>
                    <span style={{borderRadius:10,background:'#fafafa',padding:10,flex:1,display:'flex',alignItems:'center'}}>
                    {t('Plan')} <span style={{width:7}}/>
                      {draw.plan?.content.bs? 
                      <span style={{marginLeft:10,color:'white', borderRadius:20,background:theme.color.primary.main,paddingLeft:10,paddingRight:10, height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                      {draw.plan?.content?.bs==='b'?t('Big'):t('Small')}
                      </span>: (
                            draw.plan?.content.oe? 
                            (  
                              (lottery === 'WinGo'|| lottery === 'TrxWinGo') ? 
                                <span style={{background:draw.plan.content.oe==='o'?'green':'red',width:20,height:20,borderRadius:10}}/>:
                            <span style={{marginLeft:10,color:'white', borderRadius:20,background:theme.color.primary.main,paddingLeft:10,paddingRight:10, height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                            {draw.plan?.content?.oe==='o'?t('Odd'):t('Even')}
                            </span>):
                          draw.plan?.content.numbers.map((num:any)=>{
                            return <span style={{marginRight:5,color:'white', borderRadius:20,background:theme.color.primary.main,width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                              {num}
                            </span>
                          }))
                      } 
                    </span>
                    <span style={{borderRadius:10,background:'#fafafa',padding:10,flex:1,marginTop:10,display:'flex',alignItems:'center'}}> 
                    {t('Draw')}  {draw.content?<span style={{marginLeft:10,borderRadius:20,background:theme.color.primary.main,minWidth:20,height:20,paddingLeft:5,paddingRight:5,display:'flex',alignItems:'center',justifyContent:'center'}}>
                      <div style={{color:'white',textAlign:'center'}}>{draw.content.number || draw.content.sumCount}</div>
                      </span>
                    :t('Pending')}
                    </span>
                  </div>
                  <span style={{borderRadius:10,background:!draw.content?theme.color.primary.main:(hitProfiles[0].hitTrend[index-1]?'#fad9d9':'#fafafa'),padding:10,display:'flex',alignItems:'center',justifyContent:'center' }}>
                      {draw.content?
                      (hitProfiles[0].hitTrend[index-1] ?<TbTargetArrow style={{fontSize:80,color:theme.color.primary.main,fontWeight:'thin'}}/>:
                      <TbTargetOff style={{fontSize:80,color:'#bbb',fontWeight:'thin'}}/>)
                      :  <div style={{color:'white',width:80,fontSize:30,display:'flex',alignItems:'center',justifyContent:'center'}}>
                          {secondToMinuteStr(countdown||0)}
                        </div>
                    } 
                </span> 
                </div>
              </div>
            })}
            <Spacer size='md'/>
          </div>
    </Page>
  );
}; 
const StyledOverview = styled.div`
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const StyledNoticeContainer = styled.div`
  max-width: 768px;
  width: 90vw;
`;

const StyledSpacer = styled.div`
  height: ${(props) => props.theme.spacing[4]}px;
  width: ${(props) => props.theme.spacing[4]}px;
`;

const StyledLink = styled.a`
  font-weight: 700;
  text-decoration: none;
  color: ${(props) => props.theme.color.primary.main};
`;

export default Home;
